import React from 'react';
import What from "../assets/What is GPT-3.png"

function Section(props) {
    return (
        <div className="w-4/5 m-auto py-10">
            <img src={What} alt={What} />
        </div>
    );
}

export default Section;